import { Stack } from '@mui/material'
import SchoolCard from './SchoolCard'
import MySchoolTabs from './Tabs'
import { memo } from 'react'

const MySchoolSidebar = () => {
    return (
        <Stack sx={{ width: 300, gap: 3, height: '100%' }}>
            <SchoolCard />
            <MySchoolTabs />
        </Stack>
    )
}

export default memo(MySchoolSidebar)
